const arePositionsEqual = (left: readonly number[], right: readonly number[]): boolean =>
	left.length === right.length && left.every((position, index) => position === right[index]);

export default arePositionsEqual;
